import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { WizardComponent } from 'angular-archwizard';
import { DeviceDetectorService } from 'ngx-device-detector';
import { finishFormEnum } from 'src/Models/Enum/FinishFormEnum';
import { Surveys } from 'src/Models/Surveys';
import { SurveysResponse } from 'src/Models/SurveysResponse';
import { SurveyService } from '../core/service/survey.service';
import { Questions } from 'src/Models/Questions';
import { FormUtils } from '../core/form/formUtils';
import { QueryParamsUtils } from '../core/form/queryParamsUtils';
import { LogicalWizard } from '../core/form/logicalWizard';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'response-video',
  templateUrl: './response-video.component.html',
  styleUrls: ['./response-video.component.sass']
})
export class ResponseVideoComponent implements OnInit {
  @ViewChild(WizardComponent) public wizard: WizardComponent;

  @HostListener('window:beforeunload', ['$event'])
  beforeUnloadHander(event) {
    let response = new SurveysResponse();
    response = { ...this.form.value };
    if (!this._queryParamsUtils.isPreview && this.finishFormClass == false && response.participant_key != null && response.participant_key != '') {
      this.form.get('abandonment').setValue(true);
      this.finishFormClass = true;
      this.formUtils.finishForm(finishFormEnum.Abandonment);
      event.returnValue = false;
    }
  }
  isPreview: boolean = false;
  survey: Surveys = new Surveys();
  formUtils: FormUtils
  form: FormGroup;
  jsonColor: any;
  currentQuestion: any;
  objVideoSettings: any;
  objQuestionSettings: any;
  url_redirect_thanks: string;
  time_redirect_thanks: number;
  btnSubmit: string;
  finishFormClass: boolean = false;
  loaded = false;
  stepSurvey: number = 0;
  id_survey_audience: string;
  objColor: { 'background-color': any; 'border-color': string; color: any; };

  constructor(private _survey: SurveyService, private _device: DeviceDetectorService, private fb: FormBuilder,
    private router: Router, private _queryParamsUtils: QueryParamsUtils, private translate: TranslateService) {
    this.formUtils = new FormUtils(this._survey, this.form, this._queryParamsUtils, this.fb, this.router, this._device);
  }

  ngOnInit(): void {
    this._survey.postSurveyResponse(this._queryParamsUtils.id_survey, this.formUtils.device, null).then(sur => {
       this.verifySurvey(sur);
      if (this._queryParamsUtils.id_survey_audience != null) {

        this.id_survey_audience = this._queryParamsUtils.id_survey_audience
        this._survey.getAudience(this._queryParamsUtils.id_survey_audience, this._queryParamsUtils.id_survey).then(aud => this.formUtils.verifyAudience(aud)).catch(() => {
          this.router.navigate(['survey-expired'])
        });
      }
    });
    this.isPreview = this._queryParamsUtils.isPreview;
  }

  verifySurvey(s: Surveys) {
    if (s == null) {
      this.router.navigate(['404'])
    } if (!s.active) {
      this.router.navigate(['survey-expired'])
    }
    this.survey = s;
    this.formUtils.survey = s;
    this.jsonColor = this.survey.color_button != null ? JSON.parse(this.survey.color_button) : this.jsonColor;
    this.objColor = { 'background-color': this.jsonColor['background-color'], 'border-color': '#fff', 'color': this.jsonColor['color'] }
    this.form = this.formUtils.createFormPliQ();
    this.currentQuestion = this.survey.questions[0];
    this.objVideoSettings = { currentQuestion: this.currentQuestion, btnSubmit: this.textTranslate(0) };
    setTimeout(() => {
      this.loaded = true;
    }, 2000);
    this.url_redirect_thanks = '';
    this.setLanguage();
  }

  getQuestionById(id_question) {
    return this.survey.questions.find((question: Questions) => question.id_question === id_question)
  }

  nextStep(i, event) {
    const lastQuestionOBJ = this.survey.questions[i];
    let answeredQuestion = this.form.get('responses').get('data')['controls'][i];
    this.formUtils.setOthersParameters(answeredQuestion);
    const destination = lastQuestionOBJ.logical != null ? LogicalWizard.logicalNextQuestion(JSON.parse(lastQuestionOBJ.logical.toString()), answeredQuestion, this.survey, this.form) : 'next';
    let currentQuestionOBJ = LogicalWizard.getNextQuestionLogical(this.survey.questions, destination, i);

    if (currentQuestionOBJ != null) {
      if (destination === 'next') this.stepSurvey++;
      this.currentQuestion = currentQuestionOBJ;
      this.objVideoSettings = { ...event, currentQuestion: this.currentQuestion, btnSubmit: 'Próximo' };
    }
    else {
      this.currentQuestion = null;
      this.form.get('abandonment').setValue(false);
      this.finishFormClass = true;
      this.formUtils.finishForm(finishFormEnum.Default);
    }
    if (answeredQuestion.get('fk_type_question').value == 16) {
      window.location.href = lastQuestionOBJ.url_button;
    } else {
      LogicalWizard.setNextStepWizard(destination, this.wizard, this.survey.questions.length, currentQuestionOBJ != null ? currentQuestionOBJ.sequence - 1 : 0)
    }
  }

  //TODO: Implement in logical as well
  textTranslate(i) {
    return i + 1 >= this.survey.questions.length ? 'Finalizar' : 'Próximo';
  }

  setLanguage() {
    this.translate.use(this.survey.language);
  }
}

